import { line, curveLinear } from 'd3-shape';

export function renderLineSeries(parentElem, graph, panel, series, xScale, yScale) {

	const lineGenerator = line()
		.x(d => xScale(graph.config.xAxis.config.dataAccessor(d)))
		.y(d => yScale(series.config.dataAccessor(d)))
		.defined(d => series.config.dataAccessor(d) !== null)
		.curve(series.config.curve || curveLinear);

	const path = parentElem.append('path')
		.attr('class', `hw_panel_graph_series hw_panel_graph_line_series hw_panel_graph_series_${series.config.name}`)
		.attr('d', lineGenerator(graph.config.data));

	if (series.config.color !== null) {
		path.style('stroke', series.config.color);
	}

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-series-line.js